<template>
	<div>
		<div class="view-framework">
			<userLeft></userLeft>
			<div class="view-framework-body">
				<div class="view-framework-main">
					<div class="tabnavs">
						<el-tabs v-model="activeName"  @tab-click="handleClick">
							<el-tab-pane label="基本资料" name="/setting"></el-tab-pane>
							<el-tab-pane label="实名认证" name="/real"></el-tab-pane>
							<el-tab-pane label="密码管理" name="/passWord"></el-tab-pane>
							<el-tab-pane label="手机设置" v-if="userList.phone" name="/updatePhone"></el-tab-pane>
							<el-tab-pane label="绑定手机" v-if="!userList.phone" name="/bindPhone"></el-tab-pane>
							<el-tab-pane label="提现账号" name="/withdrawAccount"></el-tab-pane>
						</el-tabs>
					</div>

					<div class="box tab-content">
						<div class="userform">
							<div class="form-group">
								<label class="form-label">
									<em>*</em>
									 新登录密码：
								</label>
								<div class="form-element">
									<input type="password"  class="form-control" v-model="pass" placeholder="请输入新密码"/>
								</div>
							</div>
							<div class="form-group">
								<label class="form-label">
									<em>*</em>
									 确认新密码：
								</label>
								<div class="form-element">
									<input  type="password" class="form-control" v-model="pass_z" placeholder="请输入确认新密码"/>
								</div>
							</div>
							<div class="form-group">
								<label class="form-label">
									<em>*</em>
									 手机号：
								</label>
								<div class="form-element">
									<input  class="form-control" disabled  v-model="mobile"  placeholder="请输入手机号"/>
								</div>
							</div>
							<div class="form-group" >
								<label class="form-label">
									<em>*</em>
									 验证码：
								</label>
								<div class="form-element">
									<input  class="form-control" type="number" maxlength="6" v-model="code" placeholder="请输入验证码"/>
									<a href="javascript:;" class="text-blue" @click="getCode()" :class="{disabled:time!=0}">
										{{time === 0?'获取短信验证码':time+'秒后可重新获取'}}
									</a>
								</div>
							</div>
							<div class="form-group-btn">
								<button class="btn btn-primary" type="button" @click="updatePass">提交</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				userList:[],
				activeName:"/passWord",
				time:0,
				interval:null,
				pass:"",
				pass_z:"",
				code:"",
				mobile:""
			}
		},
		created() {
			this.activeName =  window.location.hash.replace(/[#]/g, '')
			this.userList = JSON.parse(localStorage.getItem('userInfo')) 
			this.mobile = this.$fxLink.checkHide(this.userList.phone)
		},
		methods:{
			handleClick(tab, event) {
				this.$router.push({ path:this.activeName})
			},
			updatePass(){
				if(!this.pass){
					this.$message({
						message: '请输入新密码',
						type: 'warning'
					});
					return
				}
				if(!this.pass_z){
					this.$message({
						message: '请输入确认新密码',
						type: 'warning'
					});
					return
				}
				if(this.pass != this.pass_z){
					this.$message({
						message: '两次密码不一致',
						type: 'warning'
					});
					return
				}
				if(!this.code){
					this.$message({
						message: '请输入验证码',
						type: 'warning'
					});
					return
				}
				let token = localStorage.getItem('token')
				this.$api.upPass({
					token:token,
					code:this.code,
					pass:this.pass,
					newpass:this.pass_z
				}).then(res => {
					if(res.code === 1){
						this.$message({
							message: res.msg,
							type: 'success'
						});
						setTimeout(() => {
							window.location.reload();
						},500)
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			},
			getCode(){
				if(this.$fxLink.checkPhone(this.userList.phone)){
					this.$message({
						message: '手机号格式不正确',
						type: 'warning'
					});
					return
				}
				if (this.time == 0){
					
					this.$api.passCode({
						mobile:this.userList.phone,
					}).then(res => {
						if(res.code === 1){
							this.$message({
								message: res.msg,
								type: 'warning'
							});
							this.time = 60 ;
							this.interval = setInterval(() => {
								if(this.time == 0){
									clearInterval(this.interval)
									return
								}
								this.time --
							},1000)
						}else{
							this.$message({
								message: res.msg,
								type: 'warning'
							});
							return
						}
					
					})
				}
			},
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/user/setting/passWord.vue